<template>
  <section
    class="component-cfc2194d"
    resmed-component-name="multistep_3-6_graphic-line_text"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-8 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon.icon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <figure
              v-else
              class="illustration-icon"
              v-bind:style="{
                'background-image': `url(${acf['illustration-icon']})`,
              }"
            >
              <!-- bg image -->
            </figure>
            <h2 v-html="acf.headline"></h2>
            <div
              class="mb-4"
              v-if="acf.introduction"
              v-html="acf.introduction"
            ></div>
          </div>
        </div>
        <div class="items">
          <div class="item" v-for="item in acf.items">
            <figure>
              <img class="img-fluid" v-bind:src="`${item.icon}`" alt="" />
            </figure>
            <h4 v-if="item.title" v-bind:class="[item.color]">
              {{ item.title }}
            </h4>
            <p class="content" v-html="item.description"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import scrollTarget from "../../mixins/scroll-target";

export default {
  name: "component-cfc2194d", // multistep_3-6_graphic-line_text
  props: ["acf"],
  mixins: [scrollTarget],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-cfc2194d {
  padding: 4rem 0 5rem 0;
}

.component {
  h2 {
    position: relative;
    margin: 0 0 1rem 0;

    @extend %eyebrow-center;
  }

  h4 {
    margin-bottom: 0.75rem;
  }

  figure {
    &.illustration-icon {
      margin: 0 auto 2.5rem auto;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;

      background-position: center center;
      background-size: 102px 102px;
      background-repeat: no-repeat;
      box-shadow: -3px 0.875rem 19px 2px rgba(0, 0, 0, 0.125);
    }
  }

  .items {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
    }

    .item {
      padding: 2rem 2rem 1rem 2rem;
      max-width: 360px;
      margin: 0 auto;

      @media (min-width: 768px) {
        margin: 0;
        width: 33.33%;
      }

      figure {
        max-width: 3rem;
        margin: 0 0 1rem 0;

        img {
          display: block;
        }
      }
    }
  }
}
</style>